const openMenu = { toggleFn: null, state: null };

export { openMenu };
